import { combineReducers } from '@reduxjs/toolkit'
import { channelSlice, userSlice } from 'Pages/user'

export * from './slice'
export * from './saga'
export * from './selector'

export const usersReducers = combineReducers({
	[channelSlice.name]: channelSlice.reducer,
	[userSlice.name]: userSlice.reducer,
})

export const userActions = {
	...channelSlice.actions,
	...userSlice.actions,
}
